import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";
import dayjs, { Dayjs } from "dayjs";

export const DocumentItemSchema = z.object({
  name: z.string().min(1, { message: REQUIRED_FIELD }),
  publishedAt: z.custom<Dayjs>((val) => dayjs(val).isValid(), {
    message: REQUIRED_FIELD,
  }),
  provinceOptions: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional()
    .nullable(),
  subSystemOptions: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .min(1, { message: REQUIRED_FIELD }),
  authorName: z.string().min(1, { message: REQUIRED_FIELD }),
  permission: z.object({
    id: z.number().min(1, { message: REQUIRED_FIELD }),
    name: z.string(),
  }),
});
